import React from 'react';
export function NavBar() {
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-base/80 backdrop-blur-md border-b border-border-muted" data-id="element-381">
      <div className="max-w-7xl mx-auto px-6 h-14 flex items-center justify-between" data-id="element-382"></div>
    </nav>;
}